import {
  GET_OLD_METAL_TYPES_REQUEST,
  GET_OLD_METAL_TYPES_SUCCESS,
  GET_OLD_METAL_TYPES_FAILURE,
  GET_OLD_METAL_STOCK_REQUEST,
  GET_OLD_METAL_STOCK_SUCCESS,
  GET_OLD_METAL_STOCK_FAILURE,
  UPDATE_OLD_METAL_STOCK_REQUEST,
  UPDATE_OLD_METAL_STOCK_SUCCESS,
  UPDATE_OLD_METAL_STOCK_FAILURE,
  GET_OLD_METAL_EXCHANGES_REQUEST,
  GET_OLD_METAL_EXCHANGES_SUCCESS,
  GET_OLD_METAL_EXCHANGES_FAILURE,
  GET_OLD_METAL_EXCHANGE_SUMMARY_REQUEST,
  GET_OLD_METAL_EXCHANGE_SUMMARY_SUCCESS,
  GET_OLD_METAL_EXCHANGE_SUMMARY_FAILURE,
} from '../types';
import api from '../../services/api';

// Get old metal types
export const getOldMetalTypes = () => async (dispatch) => {
  try {
    dispatch({ type: GET_OLD_METAL_TYPES_REQUEST });

    const response = await api.get('/old-metals/types');
    const data = response.data.data;

    dispatch({
      type: GET_OLD_METAL_TYPES_SUCCESS,
      payload: data,
    });

    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to get old metal types';
    dispatch({
      type: GET_OLD_METAL_TYPES_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Get old metal stock
export const getOldMetalStock = () => async (dispatch) => {
  try {
    dispatch({ type: GET_OLD_METAL_STOCK_REQUEST });

    const response = await api.get('/old-metals/stock');
    const data = response.data.data;

    dispatch({
      type: GET_OLD_METAL_STOCK_SUCCESS,
      payload: data,
    });

    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to get old metal stock';
    dispatch({
      type: GET_OLD_METAL_STOCK_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Update old metal stock
export const updateOldMetalStock = (stockData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_OLD_METAL_STOCK_REQUEST });

    const response = await api.put('/old-metals/stock', stockData);
    const data = response.data.data;

    dispatch({
      type: UPDATE_OLD_METAL_STOCK_SUCCESS,
      payload: data,
    });

    return { success: true, data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to update old metal stock';
    dispatch({
      type: UPDATE_OLD_METAL_STOCK_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Get old metal exchanges for an invoice
export const getOldMetalExchanges = (invoiceId) => async (dispatch) => {
  try {
    dispatch({ type: GET_OLD_METAL_EXCHANGES_REQUEST });

    const response = await api.get(`/old-metals/exchanges/invoice/${invoiceId}`);
    const data = response.data.data;

    dispatch({
      type: GET_OLD_METAL_EXCHANGES_SUCCESS,
      payload: data,
    });

    return { success: true, data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to get old metal exchanges';
    dispatch({
      type: GET_OLD_METAL_EXCHANGES_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Get old metal exchange summary
export const getOldMetalExchangeSummary = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_OLD_METAL_EXCHANGE_SUMMARY_REQUEST });

    const response = await api.get('/old-metals/exchanges/summary', { params });
    const data = response.data.data;

    dispatch({
      type: GET_OLD_METAL_EXCHANGE_SUMMARY_SUCCESS,
      payload: data,
    });

    return { success: true, data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to get old metal exchange summary';
    dispatch({
      type: GET_OLD_METAL_EXCHANGE_SUMMARY_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};
